import type { TAnimName } from '@common/Anim/Anim'
import type { TAnim } from '@common/Anim/animations'

export const DURATION_TYPES = [ 'slowest', 'slow', 'normal', 'fast', 'fastest' ] as const
type TDurationType = typeof DURATION_TYPES[number]

export type TDuration = TDurationType | number

type TDurationNumbers = {
  readonly [key in TDurationType]: number
}

export const DURATIONS: TDurationNumbers = {
  slowest: 1200,
  slow:    1000,
  normal:   750,
  fast:     500,
  fastest:  250
}

export type TAnimClassName = `sni-anim-${ string }`

export type TAnimNameProp = TAnimName<TAnimClassName>

export interface IAnim {
  readonly add: (
    el: Element | null,
    name: TAnimNameProp,
    duration: TDuration,
    isForce?: boolean,
    willRemoveClass?: boolean
  ) => Promise<void>
  readonly anims: TAnim
  readonly duration: typeof DURATIONS
}

export type { IAnimProps } from '@common/Anim/TSXAnim'

export type { IAnimRunProps } from '@common/Anim/Anim'

export { ANIMATIONS } from '@common/Anim/animations'
